<template>
  <div class="wrapper-logs">
    <div class="row">
      <h2 class="ml-4">Logs de Acesso</h2>
    </div>
    <div class="row mt-5">
      <form class="form-inline">
        <div class="form-group mx-sm-3 mb-2">
          <label
            for="inputPassword2"
            class="sr-only"
          >Busca</label>
          <input
            v-model="filter"
            type="text"
            class="form-control"
            id="input-search"
            placeholder="Buscar por..."
            @keyup="search"
          />
        </div>
        <button
          @click="resetSearch"
          type="button"
          class="btn btn-primary mb-2"
        >
          Limpar
        </button>
      </form>
    </div>
    <div class="row">
      <div class="col">
        <b-table
          striped
          hover
          :fields="fields"
          :items="items"
        >
          <template v-slot:cell(createdAt)="row">
            {{ formatDate(row.item.createdAt) }}
          </template>
        </b-table>
        <div class="pagination-users mb-5">
          <paginate
            v-model="page"
            :page-count="Math.ceil(this.total / this.limit)"
            :click-handler="changePage"
            :prevText="'‹'"
            :nextText="'›'"
            :activeClass="'active'"
            :containerClass="'pagination b-pagination'"
            :pageClass="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { lightFormat } from 'date-fns';

export default {
  name: 'LogsDeAcesso',
  data: () => ({
    userAuth: null,
    items: [],
    page: 1,
    filter: null,
    limit: 20,
    typingTimer: null,
    doneTypingInterval: 500,
    fields: [
      { key: 'name', label: 'Nome' },
      { key: 'email', label: 'Email' },
      { key: 'log', label: 'Ação' },
      { key: 'createdAt', label: 'Data/Hora' },
    ],
  }),
  computed: {
    ...mapState('logs', ['list', 'total']),
  },
  methods: {
    ...mapActions('logs', ['getLogs']),
    changePage() {
      this.getLogs({
        page: this.page,
        limit: this.limit,
        filter: this.filter,
      }).then(() => {
        this.items = this.list;
      });
    },
    async resetSearch() {
      this.filter = null;
      this.items = [];
      this.getLogs({
        page: this.page,
        limit: this.limit,
        filter: this.filter,
      }).then(() => {
        this.items = this.list;
      });
    },
    searchingLogs() {
      this.items = [];
      this.getLogs({
        page: this.page,
        limit: this.limit,
        filter: this.filter,
      }).then(() => {
        this.items = this.list;
      });
    },
    search() {
      if (
        this.filter !== ''
        && this.filter !== null
        && this.filter.length > 2
      ) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(
          this.searchingLogs,
          this.doneTypingInterval,
        );
      } else {
        this.items = [];
        this.getLogs({
          page: this.page,
          limit: this.limit,
          filter: null,
        }).then(() => {
          this.items = this.list;
        });
      }
    },
    formatDate(date) {
      if (date) {
        return lightFormat(new Date(date), 'dd/MM/yyyy HH:mm');
      }
      return '-';
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },
  mounted() {
    this.getLogs({
      page: 1,
      limit: this.limit,
      filter: null,
    }).then(() => {
      this.items = this.list;
    });
  },
};
</script>

<style lang="scss">
.wrapper-logs {
  max-height: 700px;
  overflow: auto;
}
</style>
